import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import EditVignette from '../../commons/EditVignette'

const ChooseAppartment = ({appartments, dispatch}) => (
    <div className="selectRoom">
        {appartments.map( appart =>
            <div className="appartment" key={appart.Id}>
                <EditVignette mode="360" appartment={appart.Id} />
                <Link to={"/360/" + appart.Id + "/" + appart.DefaultRoom}>
                    <img src={appart.VignetteUrl} alt={appart.Name} />
                </Link>
            </div>
        )}
    </div>
)

export { ChooseAppartment }

export default connect(
    (state) => state.app
)(ChooseAppartment);



// WEBPACK FOOTER //
// ./src/components/360Mode/IndexView/ChooseAppartment.js